const StudyTypes = [
  { value: "Intervational", name: "Intervational" },
  { value: "Observational", name: "Observational" },
];

export default StudyTypes;
